module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-262.5b01835d.svg";